<template>
  <ParallelEditErrorModal></ParallelEditErrorModal>
  <OrderCard
    v-if="order"
    :order="order"
    :index="orderIndex"
    :activeOrder="orderIndex"
  >
  </OrderCard>
</template>
<script setup lang="ts">
import OrderCard from "@/components/orders/OrderCard.vue";
import store from "@/store";
import { useRoute } from "vue-router";
import { ref } from "vue";
import { reAuthorize } from "@/services/auth/re-auth";
import ParallelEditErrorModal from "@/components/ParallelEditErrorModal.vue";

const order = ref(null);
const orderIndex = ref(0);
reAuthorize(store)
  .then((res) => store.dispatch("OrderStore/getOrders"))
  .then((res) => {
    order.value = store?.state?.OrderStore?.orders.find(
      (order) =>
        order.orderId == route.params.id &&
        order.orderPosition == route.params.position &&
        order.directionType == route.params.direction
    );
    orderIndex.value = store?.state?.OrderStore?.orders.findIndex(
      (order) =>
        order.orderId == route.params.id &&
        order.orderPosition == route.params.position &&
        order.directionType == route.params.direction
    );
  });
const route = useRoute();
</script>
